module.exports = __webpack_public_path__ + "static/img/装饰1.11f501b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰1.svg
// module id = T5th
// module chunks = 2